// src/utils/analyticsHelper.ts

export type AnalyticsEventParams = Record<string, any>;

export const trackEvent = (eventName: string, eventParams: AnalyticsEventParams = {}) => {
  // Google Analytics 4
  if (typeof window !== "undefined" && (window as any).gtag) {
    (window as any).gtag("event", eventName, eventParams);
  }

  // Microsoft Clarity — correct syntax
  if (typeof window !== "undefined" && (window as any).clarity) {
    try {
      (window as any).clarity("event", eventName);
    } catch (err) {
      console.warn("Clarity tracking failed:", err);
    }
  }

  // optional console debug
  if (process.env.NODE_ENV === "development") {
    console.log(`[Analytics] ${eventName}`, eventParams);
  }
};
